import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import axios from "../../../axios-defaults";

import {withTranslation} from 'react-i18next';

import LinkedAccountList from "./List";
import PageTitle from "../../Commons/PageTitle";

class LinkedAccounts extends PureComponent {
    render() {
        return (
            <div className="container container--larger linked-account-add">
                <div className="container-fluid">
                    <div className="row flex flex--wrap">
                        <div className="col-md-6">
                            <PageTitle title={this.props.t("linkedaccounts.title")}/>
                        </div>
                        <div className="col-md-6 d-flex justify-content-lg-end justify-content-around">
                            <div className="actions">
                                <div className={"button"}>
                                    <Link className='btn btn-secondary btn-sm mb-3' to={"/accounts/change-account/add"}>
                                        {this.props.t("linkedaccounts.addbtn")}&nbsp;&nbsp;
                                        <i className="far fa-plus"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <LinkedAccountList/>
                </div>
            </div>

        );
    }
}

export default withTranslation()(LinkedAccounts);
